@if (type() === "status" || content()) {
  <span [class]="containerClasses()">{{ content() }}</span>
}
